module.exports = __webpack_public_path__ + "f28eb362fb6afe946d822ee5451c2146.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold.eot
// module id = 659
// module chunks = 0